import styles from './home-page.module.scss';
import { Card, Space, Image, Row, Col, Button, Typography, Tabs, App, Table } from "antd";
import brandsStorage from "../../storages/brands";
import { observer } from 'mobx-react-lite';
import AddBrandDialog from '../../dialogs/add-brand-dialog';
import layoutStorage from '../../storages/layout-storage';
import { useEffect } from "react";
import ordersStorage from "../../storages/orders.storage";
import { IUsedItem } from "@drone-parts.garphild.pro/interfaces";
import homePageStorage from "../../storages/home-page.storage";

export function HomePage() {
  const { brands } = brandsStorage
  const { isAddBrandDialogOpened, toggleAddBrandDialog } = layoutStorage;
  const { notification } = App.useApp();

  const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  async function loadAllData() {
    ordersStorage.loadOrders();
    homePageStorage.loadStats()
  }

  useEffect(() => {
    loadAllData()
      .then(() => {
        notification.success({ message: "Full data loaded" });
      })
      .catch((error) => {
        notification.error({ message: error.message });
      });
  }, []);

  return (
    <>
      <Space direction="vertical" style={{ marginBottom: 16, width: '100%' }}>
        <Tabs
          defaultActiveKey="dashboard"
        >
          <Tabs.TabPane tab="Dashboard" key="dashboard">
            <Space direction="vertical" style={{ width: '100%' }}>
              <Typography.Title level={3}>Summary</Typography.Title>
              <Space className={styles.dashboardStatsArea} style={{ width: '100%' }}>
                <Card
                  style={{ height: '100%', width: '100%' }}
                  title="Drones"
                >
                  <Space direction="vertical"  style={{ width: '15vw' }}>
                    {Object.entries(homePageStorage.dronesByStatus || {}).sort().map((stat) => (
                      <Space className={styles.summaryCardBody}>
                        <Typography className={styles.summaryRowName}>{stat[0]}</Typography>
                        <Typography className={styles.summaryRowValue}>{stat[1]}</Typography>
                      </Space>
                    ))}
                  </Space>
                </Card>
                <Card
                  style={{height: '100%'}}
                  title="Finance"
                >
                  <Space direction="vertical"  style={{ width: '15vw' }}>
                    {Object.entries(homePageStorage.financials || {}).map((stat) => (
                      <Space className={styles.summaryCardBody}>
                        <Typography className={styles.summaryRowName}>{stat[0]}</Typography>
                        <Typography className={styles.summaryRowValue}>{USDollar.format(stat[1])}</Typography>
                      </Space>
                    ))}
                  </Space>
                </Card>
                <Card
                  style={{height: '100%'}}
                  title="Orders"
                >
                  <Space direction="vertical">
                    {ordersStorage.overallStats.map((stat) => (
                      <Space className={styles.summaryCardBody}>
                        <Typography className={styles.summaryRowName}>{stat.name}</Typography>
                        {stat.currency && <Typography className={styles.summaryRowValue}>{USDollar.format(stat.value)}</Typography>}
                        {!stat.currency && <Typography className={styles.summaryRowValue}>{stat.currency}{Number.isInteger(stat.value) ? stat.value : stat.value.toFixed(2)}</Typography>}
                      </Space>
                    ))}
                  </Space>
                </Card>
                <Card
                  style={{height: '100%'}}
                  title="Main stock"
                >
                  <Space direction="vertical">
                    {[...ordersStorage.overallCategoriesInStock.keys()]
                      .filter((statKey) => {
                        // return true;
                        return [
                          'FC Stack',
                          'VTX',
                          'Camera',
                          'Motor',
                          'Frame',
                          'Receiver',
                          'Propellers',
                          'Condensator',
                          'Antenna',
                          'Flight controller',
                          'ESC',
                          'SMA Pigtail'
                        ].includes(statKey);
                      })
                      .map((statKey) => (
                      <Space className={styles.summaryCardBody}>
                        <Typography className={styles.summaryRowName}>{statKey}</Typography>
                        <Typography className={styles.summaryRowValue}>{ordersStorage.overallCategoriesInStock.get(statKey)}</Typography>
                      </Space>
                    ))}
                  </Space>
                </Card>
              </Space>
              <Space direction="vertical" style={{width: '100%'}}>
                <Typography>To order</Typography>
                <Table
                  columns={[
                    {
                      title: 'Name',
                      dataIndex: 'shortName',
                      key: 'shortName',
                    },
                    {
                      title: 'Category',
                      dataIndex: 'category',
                      key: 'category',
                    },
                    {
                      title: 'Part',
                      dataIndex: 'part',
                      key: 'part',
                    },
                    {
                      title: 'Needed',
                      dataIndex: 'used',
                      key: 'used',
                      render: (used: IUsedItem[]) => {
                        if (!used) {
                          return 0;
                        }
                        return used.reduce((acc, item) => acc + item.quantity, 0);
                      }
                    },
                  ]}
                  dataSource={ordersStorage.itemsToOrder.filter((item) => !!item.used?.length)}
                />
              </Space>
            </Space>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Orders" key="orders">
            <Space direction="vertical">
              <Typography.Title level={3}>Orders</Typography.Title>
            </Space>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Drones" key="drone-parts">
            <Space direction="vertical">
              <Typography.Title level={3}>Drones</Typography.Title>
            </Space>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Parts" key="parts">
            <Space direction="vertical">
              <Typography.Title level={3}>Parts</Typography.Title>
            </Space>
            <Row gutter={8}>
        {brands.map((brand) => (
          <Col style={{ marginBottom: 8}}>
            <Card style={{ width: 150, height: '100%', marginBottom: 8, display: "flex", alignContent: 'space-between' }}>
              <Image src={brand.logoUrl} width='100%' />
              <div>
                {brand.siteUrl && <a href={brand.siteUrl} target="_blank" rel="noreferrer">{brand.name}</a>}
                {!brand.siteUrl && brand.name}
              </div>
              <div>items: {brand.itemsCount}</div>
            </Card>
          </Col>
        ))}
        <Col>
          <Card style={{ width: 150, marginBottom: 8, height: '100%' }}>
            <Button type="primary" onClick={toggleAddBrandDialog}>
              Add brand
            </Button>
          </Card>
        </Col>
      </Row>
          </Tabs.TabPane>
        </Tabs>
      </Space>
      <AddBrandDialog opened={isAddBrandDialogOpened} onToggle={toggleAddBrandDialog} />
    </>
  );
}

export default observer(HomePage);
